import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    billList: [],
    coinList: [],
    totalCount: 0,
    pagination: {
      page: 1,
      size: 10
    }
  },
  getters: {},
  mutations: {
    setpage(state, page) {
      state.pagination = page;
    },
    setUserBillList(state, payload) {
      state.billList = payload.list;
      state.totalCount = payload.totalCount;
    },
    setCoinList(state, payload) {
      state.coinList = payload;
    }
  },
  actions: {
    listAllCoin({ commit }) {
      api.getAllCoin().then(({ data }) => {
        commit('setCoinList', data);
      });
    },
    reRecharge(context, data) {
      return api.reRecharge(data);
    },
    reReset(context, data) {
      return api.reReset(data);
    },
    getUserBillList({ commit }, content) {
      api.getUserBillList(content).then(({ data }) => {
        commit('setUserBillList', data);
      });
    }
  }
};

appStore.registerModule('abnormal', store);
